import Icons from "../exports/Icons";

const SkillsData = [
  {
    skillSet: "Frameworks and Libraries",
    color: "bg-purple-500",
    technologies: [
      {
        name: "React",
        icon: Icons.reactIcon,
      },
      {
        name: "React Native",
        icon: Icons.reactNativeIcon,
      },
      {
        name: "Django",
        icon: Icons.djangoIcon,
      },
      {
        name: "Angular",
        icon: Icons.angularIcon,
      },
      {
        name: "Ionic",
        icon: Icons.ionicIcon,
      },
      {
        name: "Bootstrap",
        icon: Icons.bootstrapIcon,
      },
      {
        name: "Material UI",
        icon: Icons.materialUIIcon,
      },
      {
        name: "Tailwind",
        icon: Icons.tailwindcssIcon,
      },
      {
        name: "Three.js",
        icon: Icons.threejsIcon,
      },
      // {
      //   name: "GSAP",
      //   icon: Icons.gsapIcon,
      // },
    ],
  },
  {
    skillSet: "Programming Languages",
    color: "bg-green-500",
    technologies: [
      {
        name: "Python",
        icon: Icons.pythonIcon,
      },
      {
        name: "JavaScript",
        icon: Icons.javascriptIcon,
      },
      {
        name: "TypeScript",
        icon: Icons.typescriptIcon,
      },
      {
        name: "Unix Shell Scripting",
        icon: Icons.unixShellScriptIcon,
      },
      {
        name: "Java",
        icon: Icons.javaIcon,
      },
      // {
      //     'name': 'HTML',
      //     'icon': Icons.htmlIcon
      // },
      // {
      //     'name': 'CSS',
      //     'icon': Icons.cssIcon
      // },
      // {
      //     'name': 'SASS',
      //     'icon': Icons.sassIcon
      // },
      // {
      //     'name': 'SQL',
      //     'icon': Icons.sqlIcon
      // },
      // {
      //     'name': 'GraphQL',
      //     'icon': Icons.graphqlIcon
      // },
      // {
      //     'name': 'PHP',
      //     'icon': Icons.phpIcon
      // },
    ],
  },
  {
    skillSet: "Programming Technologies",
    color: "bg-red-600",
    technologies: [
      {
        name: "MySql",
        icon: Icons.mySqlIcon,
      },
      {
        name: "Sqlite3",
        icon: Icons.sqlite3Icon,
      },
      {
        name: "Cloud Computing",
        icon: Icons.cloudComputingIcon,
      },
      {
        name: "Docker",
        icon: Icons.dockerIcon,
      },
      {
        name: "Git",
        icon: Icons.gitIcon,
      },
      {
        name: "Postman",
        icon: Icons.postmanIcon,
      },
      // {
      //     'name': 'Kubernetes',
      //     'icon': Icons.kubernetesIcon
      // },
      // {
      //     'name': 'AWS',
      //     'icon': Icons.awsIcon
      // },
      // {
      //     'name': 'Firebase',
      //     'icon': Icons.firebaseIcon
      // },
      // {
      //     'name': 'Heroku',
      //     'icon': Icons.herokuIcon
      // },
      // {
      //     'name': 'Netlify',
      //     'icon': Icons.netlifyIcon
      // },
      // {
      //     'name': 'Vercel',
      //     'icon': Icons.vercelIcon
      // },
    ],
  },
  {
    skillSet: "Programming Methodologies",
    color: "bg-orange-500",
    technologies: [
      {
        name: "Data Structures and Algorithms",
        icon: Icons.dsaIcon,
      },
      {
        name: "Object Oriented Programming",
        icon: Icons.oopsIcon,
      },
      {
        name: "Agile",
        icon: Icons.agileIcon,
      },
      {
        name: "Search Engine Optimization",
        icon: Icons.seoIcon,
      },
      // {
      //     'name': 'Scrum',
      //     'icon': Icons.scrumIcon
      // },
      // {
      //     'name': 'Kanban',
      //     'icon': Icons.kanbanIcon
      // },
      // {
      //     'name': 'Waterfall',
      //     'icon': Icons.waterfallIcon
      // },
      // {
      //     'name': 'DevOps',
      //     'icon': Icons.devOpsIcon
      // }
    ],
  },
  // {
  //     'skillSet': 'Tools',
  //     'color': 'bg-blue-500',
  //     'technologies': [
  //         {
  //             'name': 'Git',
  //             'icon': Icons.gitIcon
  //         },
  //         {
  //             'name': 'GitHub',
  //             'icon': Icons.githubIcon
  //         },
  //         {
  //             'name': 'GitLab',
  //             'icon': Icons.gitlabIcon
  //         },
  //         {
  //             'name': 'Jira',
  //             'icon': Icons.jiraIcon
  //         },
  //         {
  //             'name': 'Confluence',
  //             'icon': Icons.confluenceIcon
  //         },
  //         {
  //             'name': 'Slack',
  //             'icon': Icons.slackIcon
  //         },
  //         {
  //             'name': 'Trello',
  //             'icon': Icons.trelloIcon
  //         },
  //         {
  //             'name': 'Docker',
  //             'icon': Icons.dockerIcon
  //         },
  //         {
  //             'name': 'Kubernetes',
  //             'icon': Icons.kubernetesIcon
  //         },
  //     ]
  // },
];

export default SkillsData;
